import React from "react";
import logoDark from "../../assets/logo-dark.png";

export const YELLOW = "#F4B41A";
export const NAVY = "#0A1530";
export const sans = "'Hanken Grotesk',sans-serif";
export const display = "'Space Grotesk',sans-serif";

/* Shared chrome (sticky nav + hero + footer) for legal pages (Privacy Policy, Terms of Service). */
export function LegalLayout({ title, subtitle, meta, crossHref, crossLabel, tocItems, ctaHref, ctaEyebrow, ctaLabel, children }) {
  return (
    <div style={{ background: "#F7F8FA", color: "#0B1A3A", fontFamily: sans }}>
      <style>{`
        .xw-legal a { text-decoration: none; transition: color .18s; }
        .xw-toc a { display:block; padding:7px 0; font-size:13.5px; color:rgba(11,26,58,0.6); text-decoration:none; border-left:2px solid rgba(11,26,58,0.1); padding-left:14px; transition:color .18s, border-color .18s; }
        .xw-toc a:hover { color:#0B1A3A; border-color:${YELLOW}; }
        @media (max-width: 900px) {
          .xw-legal-grid { grid-template-columns: 1fr !important; }
          .xw-toc-wrap { display: none !important; }
          .xw-pad { padding-left: 22px !important; padding-right: 22px !important; }
          .xw-legal-title { font-size: 38px !important; }
        }
      `}</style>

      <div className="xw-legal" style={{ position: "sticky", top: 0, zIndex: 50, background: "rgba(10,21,48,0.9)", backdropFilter: "blur(14px) saturate(1.3)", WebkitBackdropFilter: "blur(14px) saturate(1.3)", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <div className="xw-pad" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "20px", padding: "14px 56px", maxWidth: "1180px", margin: "0 auto" }}>
          <a href="/" style={{ display: "block" }}>
            <img src={logoDark} alt="Xenwealth" style={{ height: "26px", width: "auto", display: "block" }} />
          </a>
          <div style={{ display: "flex", alignItems: "center", gap: "26px" }}>
            <a href={crossHref} style={{ fontSize: "13.5px", fontWeight: 600, color: "rgba(255,255,255,0.72)" }}>{crossLabel}</a>
            <a href="/" style={{ fontSize: "13px", fontWeight: 700, color: NAVY, background: YELLOW, padding: "11px 22px", borderRadius: "100px" }}>Back to site</a>
          </div>
        </div>
      </div>

      <div style={{ background: "linear-gradient(180deg,#0A1530 0%,#0E1D3E 100%)", color: "#fff", padding: "76px 56px 68px" }}>
        <div className="xw-pad" style={{ maxWidth: "1180px", margin: "0 auto" }}>
          <div style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "0.18em", textTransform: "uppercase", color: YELLOW, marginBottom: "18px" }}>Legal</div>
          <h1 className="xw-legal-title" style={{ fontFamily: display, fontWeight: 700, fontSize: "58px", lineHeight: 1.04, letterSpacing: "-0.03em", margin: "0 0 20px" }}>{title}</h1>
          <p style={{ fontSize: "18px", lineHeight: 1.65, color: "rgba(255,255,255,0.7)", maxWidth: "620px", margin: 0 }}>{subtitle}</p>
          <div style={{ display: "flex", gap: "32px", flexWrap: "wrap", marginTop: "34px", paddingTop: "24px", borderTop: "1px solid rgba(255,255,255,0.14)" }}>
            {meta.map(([label, value]) => (
              <div key={label}>
                <div style={{ fontSize: "11.5px", fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(255,255,255,0.45)", marginBottom: "6px" }}>{label}</div>
                <div style={{ fontSize: "15px", fontWeight: 600 }}>{value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="xw-pad" style={{ maxWidth: "1180px", margin: "0 auto", padding: "64px 56px 90px" }}>
        <div className="xw-legal-grid" style={{ display: "grid", gridTemplateColumns: "230px 1fr", gap: "64px", alignItems: "start" }}>
          <div className="xw-toc-wrap" style={{ position: "sticky", top: "96px" }}>
            <div style={{ fontSize: "11.5px", fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: "rgba(11,26,58,0.45)", marginBottom: "14px" }}>On this page</div>
            <div className="xw-toc">
              {tocItems.map(([id, label]) => (
                <a key={id} href={`#${id}`}>{label}</a>
              ))}
            </div>
          </div>

          <div style={{ maxWidth: "760px" }}>
            {children}

            <div style={{ background: NAVY, color: "#fff", borderRadius: "18px", padding: "32px", marginTop: "44px" }}>
              <div style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", color: YELLOW, marginBottom: "14px" }}>{ctaEyebrow}</div>
              <div style={{ fontSize: "16.5px", lineHeight: 1.8, color: "rgba(255,255,255,0.78)" }}>
                xenwealthmy@gmail.com<br />
                Suite 10-31, Level 10, Lobby 8, Block A,<br />
                Damansara Intan, 47400 Petaling Jaya, Selangor
              </div>
              <a href={ctaHref} style={{ display: "inline-block", marginTop: "24px", fontSize: "14.5px", fontWeight: 700, color: NAVY, background: "linear-gradient(180deg,#ffd045,#F4B41A)", padding: "14px 28px", borderRadius: "100px" }}>{ctaLabel}</a>
            </div>
            <p style={{ fontSize: "13.5px", lineHeight: 1.7, color: "rgba(11,26,58,0.45)", margin: "22px 0 0" }}>This {title.toLowerCase()} is provided for information and should be reviewed by your legal adviser before publication.</p>
          </div>
        </div>
      </div>

      <div style={{ padding: "52px 56px 40px", background: "#070F22", color: "#fff", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
        <div className="xw-pad" style={{ maxWidth: "1180px", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "24px", flexWrap: "wrap" }}>
          <img src={logoDark} alt="Xenwealth" style={{ height: "26px", width: "auto", display: "block" }} />
          <div style={{ display: "flex", gap: "26px", alignItems: "center", flexWrap: "wrap" }}>
            <a href="/" style={{ fontSize: "14px", color: "rgba(255,255,255,0.7)" }}>Home</a>
            <a href={crossHref} style={{ fontSize: "14px", color: "rgba(255,255,255,0.7)" }}>{crossLabel}</a>
            <span style={{ fontSize: "13px", color: "rgba(255,255,255,0.4)" }}>© 2026 Xenwealth Group</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function Section({ id, heading, children }) {
  return (
    <section id={id} style={{ scrollMarginTop: "96px", marginBottom: "44px" }}>
      <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: "26px", letterSpacing: "-0.02em", margin: "0 0 14px" }}>{heading}</h2>
      {children}
    </section>
  );
}

export function P({ children, last }) {
  return <p style={{ fontSize: "16.5px", lineHeight: 1.75, color: "rgba(11,26,58,0.72)", margin: last ? 0 : "0 0 14px" }}>{children}</p>;
}

export function BulletList({ items }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {items.map((text, i) => (
        <div key={i} style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
          <span style={{ color: YELLOW, fontWeight: 800, fontFamily: display, fontSize: "15px", lineHeight: 1.75 }}>›</span>
          <span style={{ fontSize: "16.5px", lineHeight: 1.75, color: "rgba(11,26,58,0.72)" }}>{text}</span>
        </div>
      ))}
    </div>
  );
}

export function InfoCard({ label, children }) {
  return (
    <div style={{ background: "#fff", border: "1px solid rgba(11,26,58,0.1)", borderRadius: "14px", padding: "20px" }}>
      <div style={{ fontSize: "13px", fontWeight: 700, color: YELLOW, marginBottom: "8px" }}>{label}</div>
      <div style={{ fontSize: "14.5px", lineHeight: 1.65, color: "rgba(11,26,58,0.7)" }}>{children}</div>
    </div>
  );
}

export function Callout({ children, label = "Important", style }) {
  return (
    <div style={{ background: "#fff", border: "1px solid rgba(244,180,26,0.45)", borderRadius: "16px", padding: "24px 26px", marginBottom: "44px", boxShadow: "0 1px 0 rgba(11,26,58,0.04)", ...style }}>
      <div style={{ fontSize: "12px", fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "#b9860a", marginBottom: "10px" }}>{label}</div>
      <div style={{ fontSize: "16px", lineHeight: 1.7, color: "rgba(11,26,58,0.75)" }}>{children}</div>
    </div>
  );
}
